<template>
  <div
    class="items-center justify-end hidden space-x-2 lg:flex lg:flex-1 lg:w-0 flex-nowrap"
  >
    <SwitchLocale />
    <a
      :href="
        useRuntimeConfig().public.app_user_url + '/sign-in?locale=' + locale
      "
      target="_blank"
      rel="noopener noreferrer"
      class="rounded-lg h-11 px-5 bg-white text-neutrals-15 shadow-button font-bold whitespace-nowrap transition hidden xl:inline-flex items-center"
      >{{ $t("login") }}</a
    >
    <a
      :href="
        useRuntimeConfig().public.app_user_url + '/sign-up?locale=' + locale
      "
      target="_blank"
      rel="noopener noreferrer"
      class="rounded-lg h-11 px-5 bg-success text-white font-bold whitespace-nowrap transition inline-flex items-center"
      >{{ $t("sign_up") }}</a
    >
  </div>
</template>
<script setup>
import SwitchLocale from "./language/SwitchLocale.vue";
const { locale } = useI18n();
</script>
